module.exports = __webpack_public_path__ + "static/11-THE-MOST-IMPORTANT-SKILL-TO-SUCCEED-4a92ead995dc21d9df47fd3f5323f379.png";